export default function routing($stateProvider) {
    $stateProvider
        .state('subscriber', {
            url: '/subscriber',
            abstract: true,
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:INDEX'
            }
        })

        .state('subscriber.index', {
            url: '/',
            controller: 'SubscriberCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/subscriber/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:INDEX'
            }
        })

        .state('subscriber.folder', {
            url: '/folder/{folder}',
            controller: 'SubscriberCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/subscriber/index.html'),
            ncyBreadcrumb: {
                parent: 'subscriber',
                label: 'BREADCRUMBS:SUBSCRIBER:INDEX'
            }
        })

        .state('subscriber.import', {
            url: '/import?tagId',
            controller: 'SubscriberImportCtrl',
            controllerAs: 'import',
            template: require('../../../views/subscriber/import.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:IMPORT',
                parent: 'subscriber.index'
            }
        })

        .state('subscriber.importReport', {
            url: '/import/{id:int}/report',
            controller: 'SubscriberImportReportCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/subscriber/import-report.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:IMPORT_REPORT',
                parent: 'subscriber.index'
            }
        })

        .state('subscriber.subscriberForm', {
            url: '/subscriber-form',
            controller: 'SubscriberFormCtrl',
            controllerAs: 'index',
            template: require('../../../views/subscriber/subscriberForm/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:IMPORT_SUBSCRIBER_FORM',
                parent: 'subscriber.index'
            }
        })

        .state('subscriber.show', {
             url: '/{id}',
             controller: 'SubscriberShowCtrl',
             controllerAs: 'ctrl',
             template: require('../../../views/subscriber/show.html'),
             ncyBreadcrumb: {
                 label: 'BREADCRUMBS:SUBSCRIBER:SHOW',
                 parent: 'subscriber.index'
             }
        })
        
        .state('subscriber.folder.show', {
            url: '/{id:int}',
            controller: 'SubscriberShowCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/subscriber/show.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:SHOW',
                parent: 'subscriber.folder'
            }
        })

        .state('subscriber.show.subFolder', {
            url: '/{subFolder}',
            controller: 'SubscriberShowCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/subscriber/show.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:SHOW',
                parent: 'subscriber.index'
            }
        })

        .state('subscriber.folder.show.subFolder', {
            url: '/{subFolder}',
            controller: 'SubscriberShowCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/subscriber/show.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:SHOW',
                parent: 'subscriber.folder'
            }
        })
}

routing.$inject = ['$stateProvider'];
